import AdminAPI from 'config/api/AdminAPI';
import { isObject } from 'helpers/ArrayHelper';
import { getPaymentTypeObj } from 'helpers/DataHelper';
import APIService, { type ApiResponse } from 'services/api.service';
export type ApiResult<T = unknown> = T | ApiResponse | ArrayBuffer;
export interface callback {
  status: boolean;
  response: ApiResponse;
}
export interface callbackResponse {
  data?: object | null;
}
export type callbackType<T = unknown> = T | callbackResponse | ArrayBuffer;
export const manageAPICall = async (
  apiurl: string,
  method: string,
  data: object | null,
  callback?: (status: boolean, response: object) => void
) => {
  let response: ApiResult;
  if (method == 'GET') {
    response = await APIService.getData(apiurl, data);
  } else if (method == 'POST') {
    response = await APIService.submitData(apiurl, data);
  } else if (method == 'PATCH') {
    response = await APIService.submitPatchData(apiurl, data);
  } else if (method == 'DELETE') {
    response = await APIService.deleteData(apiurl, data);
  } else if (method == 'POSTFORMDATA') {
    response = await APIService.submitFormData(apiurl, data);
  } else if (method == 'POST_BUFFER_DATA') {
    response = await APIService.submitBufferData(apiurl, data);
  } else if (method == 'POSTFORMDATA_STREAM') {
    response = await APIService.submitFormDataStream(apiurl, data as FormData);
    return response;
  }
  if (response) {
    if (callback) {
      let status = true;

      if (
        isObject(response) &&
        'status' in response &&
        typeof (response as ApiResponse).status === 'boolean'
      ) {
        status = (response as ApiResponse).status;
      }

      callback(status, response as object); // cast safely for callback
      return;
    }
    return response;
  }
};
// job title.........
export const paymentTypeList = async (params: any, callback: any) => {
  const payload = params;
  const response: any = await manageAPICall(
    AdminAPI.paymentTypeList.url,
    AdminAPI.paymentTypeList.method,
    payload
  );
  if (response && response.status) {
    callback(response.data);
  }
};
export const paymentTypeOptions = (inputValue: string, setDisabled = false) =>
  new Promise((resolve) => {
    const payload = {
      filters: {
        name: inputValue,
      },
      limit: 10,
    };
    paymentTypeList(payload, (responseData: any) => {
      const listData: any = [];
      responseData.data.forEach(function (element: any) {
        listData.push(getPaymentTypeObj(element, setDisabled));
      });
      resolve(listData);
    });
  });
